// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bls-log-blsLogWrapper-e0284{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.bls-log-blsLog-a5525 .bls-log-title-wrapper-89ae7 .bls-log-title-fbec4{color:var(--GRAY_2);font-family:PingFangSC-Medium;font-size:16px;font-weight:500;line-height:22px}.bls-log-blsLog-a5525 .bls-log-title-wrapper-89ae7 .bls-log-subtitle-6c0a2{color:var(--GRAY_5);font-family:PingFangSC-Regular;font-size:12px;font-weight:400;line-height:20px;margin-top:4px}.bls-log-blsLog-a5525 .bls-log-extra-0cfa9 .bls-log-refresh-01dda{margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blsLogWrapper": "bls-log-blsLogWrapper-e0284",
	"blsLog": "bls-log-blsLog-a5525",
	"title-wrapper": "bls-log-title-wrapper-89ae7",
	"titleWrapper": "bls-log-title-wrapper-89ae7",
	"title": "bls-log-title-fbec4",
	"subtitle": "bls-log-subtitle-6c0a2",
	"extra": "bls-log-extra-0cfa9",
	"refresh": "bls-log-refresh-01dda"
};
export default ___CSS_LOADER_EXPORT___;
